import ReactDOM from 'react-dom';
import withSideEffect from 'react-side-effect';

// this will take any react children components and render them in the target selector
export default function PortalHOC(targetSelector) {
  function reducePropsToState(propsList) {
    let el;
    propsList.forEach((props) => {
      el = props.children;
    });
    return el;
  }

  function handleStateChangeOnClient(el) {
    const node = document.querySelector(targetSelector);
    if (el) {
      ReactDOM.render(el, node);
    } else {
      ReactDOM.unmountComponentAtNode(node);
    }
  }

  return withSideEffect(
    reducePropsToState,
    handleStateChangeOnClient
  )(() => null);
}
